import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import panel from "./panel";
export default {
  components: {
    panel: panel
  },
  props: {
    validityDate: {
      type: String,
      default: '2022-05-10'
    },
    // 根据版本号进行充值
    version: {
      type: String,
      default: 'standard'
    }
  },
  computed: {
    typeName: function typeName() {
      if (this.version === 'standard') {
        return '标准版会员';
      } else if (this.version === 'speciality') {
        return '专业版会员';
      } else if (this.version === 'enjoy') {
        return '尊享版会员';
      } else {
        return '定制平台';
      }
    }
  },
  filters: {
    dateFilters: function dateFilters(e) {
      if (!e) return '';
      var list = e.split('-');
      return "".concat(list[0], "\u5E74").concat(list[1], "\u6708").concat(list[2], "\u65E5");
    }
  },
  data: function data() {
    return {
      time: 5
    };
  },
  created: function created() {// const timer
    // const timer = setInterval(() => {
    //     if (this.time === 0) {
    //         this.end(timer)
    //         return
    //     }
    //     this.time--
    // }, 1000)
    // this.$once('hook:beforeDestroy', () => {
    //     clearInterval(timer)
    // })
  },
  methods: {
    end: function end() {
      window.localStorage.clear();
      window.sessionStorage.clear();
      window.location.reload(true);
      this.$memberShow.hide();
    }
  }
};